import { useId } from 'react'
import { TrashIcon, Mtds, XIcon, ModalDialog } from '../../index'

type ConfirmDeletionModalProps = {
  isOpen: boolean
  setOpen: (isOpen: boolean) => void
  onConfirm: () => void
  title: string
  isPending?: boolean
  heading?: string
  confirmLabel?: string
}

export const ConfirmDeletionModal = ({
  isOpen,
  setOpen,
  onConfirm,
  title,
  isPending = false,
  heading = 'Bekreft sletting',
  confirmLabel = 'Slett'
}: ConfirmDeletionModalProps) => {
  const id = useId()
  return (
    <ModalDialog
      id={'confirm-deletion-modal-' + id}
      closedby='any'
      open={isOpen}
      onClose={() => setOpen(false)}
    >
      <Mtds.Button
        command='close'
        commandfor={'confirm-deletion-modal-' + id}
        aria-label={'Lukk'}
      />
      <Mtds.Prose>
        <Mtds.Heading>{heading}</Mtds.Heading>
        <p>{title}</p>
        <Mtds.Flex style={{ paddingTop: 'var(--mtds-8)' }}>
          <Mtds.Button
            command='close'
            commandfor={'confirm-deletion-modal-' + id}
          >
            <XIcon />
            Avbryt
          </Mtds.Button>
          <Mtds.Button
            data-variant='primary'
            data-color='danger'
            onClick={onConfirm}
            aria-busy={isPending}
            disabled={isPending}
          >
            <TrashIcon />
            {confirmLabel}
          </Mtds.Button>
        </Mtds.Flex>
      </Mtds.Prose>
    </ModalDialog>
  )
}
